module.exports = __webpack_public_path__ + "img/生产者感言图标.d0bb1799.svg";